import { safeJsonParse } from '@halo/utils';
import type { StickerSetType } from '../sdk';
import { StickerCategory } from '../sdk';
import { AbstractApi } from './Api';

export class EmojiApi extends AbstractApi {
  getStickerSets(setType: StickerSetType) {
    return this.client.invoke('getStickerSets', [setType]);
  }
  getStickerDetail({ set_ids }: { set_ids: string[] }) {
    return this.client.invoke('getStickerDetail', [set_ids]).then((res) => {
      Object.values(res).forEach((items) => {
        items.forEach((item) => {
          if (item.render_data) {
            try {
              item.render_data = safeJsonParse(item.render_data as unknown as string, {});
            } catch (_error) {
              /* empty */
            }
          }
        });
      });

      return res;
    });
  }
  getStickerData({
    sticker_id,
    set_id = '',
    extra = 'hcs',
    category = StickerCategory.Emoji,
  }: {
    sticker_id: string;
    set_id?: string;
    extra?: string;
    category?: StickerCategory;
  }) {
    return this.client
      .invoke('getStickerData', [set_id, sticker_id, extra, category])
      .then((res) => {
        res.render_data = safeJsonParse(res.render_data as unknown as string, {});
        return res;
      });
  }
}
